import React from 'react';
import { Separator } from '@/components/ui/separator';
import { cn } from '@/lib/utils';

export interface MobileNavSectionProps {
  heading?: string;
  children: React.ReactNode;
  showSeparator?: boolean;
  ariaLabel?: string;
  className?: string;
}

export const MobileNavSection: React.FC<MobileNavSectionProps> = ({
  heading,
  children,
  showSeparator = false,
  ariaLabel,
  className,
}) => {
  const content = (
    <>
      {showSeparator && <Separator />}
      <div className={cn('px-6 py-4', className)}>
        {heading && <h3 className="text-table-header mb-3">{heading}</h3>}
        {children}
      </div>
    </>
  );

  if (ariaLabel) {
    return (
      <nav role="navigation" aria-label={ariaLabel}>
        {content}
      </nav>
    );
  }

  return content;
};
